import React from "react";
import { Button, Label } from "reactstrap";
import styles from "./FutureButton.scss";

const FutureButton = ({
  label,
  handleClick,
  icon,
  marginRightIcon,
  iconSvg,
  style,
  labelStyle,
  active
}) => {
  return (
      <button
        className={active ? styles.activeFilter : styles.btnGeneric}
        onClick={handleClick}
        >
        <Label style={{ marginRight: marginRightIcon, ...labelStyle }}>{label}</Label>
        {icon && <i className={`${icon} `}></i>}
        {iconSvg &&
          iconSvg.map((icon, index) => {
            return (
              <img
                key={"buttonIcon" + index}
                style={{ height: "14px", width: icon.width }}
                src={icon.item}
              ></img>
            );
          })}
      </button>
  );
};
export default FutureButton;